import React, { forwardRef } from 'react';
import Button from './Button';
import Icon from './Icon';

/** Icon-only button. `label` is required: it becomes the accessible name and the tooltip. */
const IconButton = forwardRef(function IconButton(
    { icon, label, size = 'md', variant = 'ghost', tone, className = '', ...rest },
    ref
) {
    return (
        <Button
            ref={ref}
            variant={variant}
            size={size}
            iconOnly
            aria-label={label}
            title={rest.title || label}
            className={className}
            leadingIcon={<Icon glyph={icon} size="sm" tone={tone} />}
            {...rest}
        />
    );
});

export default IconButton;
